/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum UserAvailabilityType {
  AVAILABLE = 'available',
  BLOCKED = 'blocked',
}
